var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReschedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#2D6CDF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18161_187241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.932 12.6352L14.7445 14.7445C14.9517 14.8999 15.2454 14.858 15.4008 14.6508C15.5562 14.4436 15.5142 14.1499 15.307 13.9945L12.7031 12.0234V8.03906C12.7031 7.78008 12.4934 7.57031 12.2344 7.57031C11.9754 7.57031 11.7656 7.78008 11.7656 8.03906V12.2578C11.7656 12.4134 11.8308 12.5536 11.932 12.6352Z",
    fill: "#2D6CDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4685 4.99219C9.03746 4.99219 6.10753 7.4686 5.53566 10.8516L5.35753 10.5867C5.21245 10.3718 4.92089 10.3151 4.70597 10.4602C4.49104 10.6052 4.43432 10.8968 4.5794 11.1117L5.51691 12.518C5.59401 12.6352 5.71964 12.7118 5.85909 12.7266H5.90597C6.03019 12.7261 6.14902 12.6764 6.23644 12.5883L7.40832 11.4164C7.59136 11.2334 7.59136 10.9362 7.40832 10.7531C7.22527 10.5701 6.92808 10.5701 6.74503 10.7531L6.45441 11.0461C6.99417 7.72407 10.1247 5.46891 13.4465 6.00867C16.7683 6.54844 19.024 9.67876 18.4842 13.0008C18.0049 15.9507 15.457 18.1177 12.4685 18.1172C10.5836 18.1514 8.80098 17.2622 7.69425 15.736C7.54402 15.525 7.25128 15.4756 7.04035 15.6258C6.82941 15.776 6.77996 16.0688 6.93019 16.2797C8.21176 18.0544 10.2799 19.0906 12.4685 19.0547C16.3519 19.0547 19.4998 15.9068 19.4998 12.0235C19.4998 8.14009 16.3519 4.99219 12.4685 4.99219Z",
    fill: "#2D6CDF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18161_187241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.75,
    height: 15.75,
    fill: "white",
    transform: "translate(3.75 4.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReschedule);
export default __webpack_public_path__ + "static/media/reschedule.6c030220c8677c5b925cb122cf9c66f2.svg";
export { ForwardRef as ReactComponent };